import { action, observable } from "mobx";
import { cacheBtnPerms, cacheUserInfo } from "@utils/auth";

import apiUrl from "@const/apiUrl";
import baseState from "../baseState";
import menuPageMap from "@/router/pageMap";
import { otherMenu } from "@/router";
import request from "@utils/request";

function handleRoutes(menuMap, parentPath = '/') {
	let routes = [];
	menuMap.map(route => {
		const { children, name, routePath, component } = route;
		const path = parentPath + routePath;
		if (children)
			routes = routes.concat(handleRoutes(route.children, path + '/'));
		else {
			let item = {
				path,
				name,
			};
			if (component && menuPageMap[component])
				item.component = menuPageMap[component];

			routes.push(item);
		}
	});
	return routes;
}

export default class appState extends baseState {
	@observable userInfo = {}; // 用户信息
	@observable appLoaded = false; // 页面初始化加载是否完毕
	@observable menus = []; // 菜单
	@observable permissions = []; // 权限
	@observable pathnameMenus = []; // 有完整pathname和组件的菜单数组
	@observable platformInfo = {}; // 平台信息，logo名称背景图

	@action
	setUserInfo(data) {
		const { admin = {}, menus = [], permissions = [] } = data;
		this.userInfo = admin;
		this.menus = menus || [];
		// 缓存路由
		window.sessionStorage.setItem("menus", JSON.stringify(menus));

		this.permissions = permissions;
		this.pathnameMenus = handleRoutes([...menus, ...otherMenu]);
		cacheBtnPerms(permissions);
		cacheUserInfo(admin);
	}

	@action
	setAppLoaded(bool) {
		this.appLoaded = bool;
	}

	// 获取用户信息
	getUserInfo = () => {
		return this.fetch({
			url: apiUrl.GET_USER_INFO,
			method: 'get',
			setState: this.setUserInfo,
		});
	};

	@action
	setPlatform(data) {
		window.sessionStorage.setItem("platform", JSON.stringify(data));
	}

	getPlatformInfo = (data) => {
		return this.fetch({
			url: apiUrl.GET_LOGO,
			method: 'get',
			data: data,
			setState: this.setPlatform,
		});
	}

  // 获取全局报警异常条数
  getWarnAlert = () => {
    return this.fetch({
      url: apiUrl.COMMON.WARN_ALERT,
      method: 'get',
    });
  }

  // 获取全局紧急告警弹窗数据（SOS+跌倒、待处理、未关闭）
  getEmergencyAlarms = () => {
    return this.fetch({
      url: apiUrl.COMMON.EMERGENCY_ALARMS,
      method: 'get',
    });
  }

  // 关闭紧急告警弹窗（路径参数 id）
  closeEmergencyAlarm = (id) => {
    return this.fetch({
      url: apiUrl.COMMON.CLOSE_ALARM + id,
      method: 'post',
    });
  }

  // 弹窗告警设置回显
  getAlarmPopupSetting = () => {
    return this.fetch({
      url: apiUrl.COMMON.ALARM_POPUP_SETTING,
      method: 'get',
    });
  }

  // 保存弹窗告警设置
  setAlarmPopupSetting = (data) => {
    return this.fetch({
      url: apiUrl.COMMON.ALARM_POPUP_SETTING,
      method: 'post',
      data,
    });
  }

  // 定位更新频率回显（工作台，返回 { frequency, editable }，超管 editable=false）
  getLocationFrequency = () => {
    return this.fetch({
      url: apiUrl.COMMON.LOCATION_FREQUENCY,
      method: 'get',
    });
  }

  // 保存定位更新频率（工作台，frequency: 1/5/15/30/60 分钟，超管后端拒绝）
  setLocationFrequency = (data) => {
    return this.fetch({
      url: apiUrl.COMMON.LOCATION_FREQUENCY,
      method: 'post',
      data,
    });
  }

}
// 登录
export function login(userInfo) {
	return request({
		url: apiUrl.LOGIN,
		data: userInfo,
	});
}

export function logout() {
	return request({
		url: apiUrl.LOGOUT,
	});
}

export function updatePwd(data) {
	return request({
		url: apiUrl.UPDATE_PWD,
		data,
	});
}

export function getSMS(data) {
	return request({
		url: apiUrl.VERIFY_CODE,
		data,
	});
}
// 注册
export function getRegSMS(data) {
	return request({
		url: apiUrl.REG_VERIFY_CODE,
		data,
	});
}
export function reg(data) {
	return request({
		url: apiUrl.REG,
		data,
	});
}
// 忘记密码
export function getForgetSMS(data) {
	return request({
		url: apiUrl.FORGET_VERIFY_CODE,
		data,
	});
}
export function forget(data) {
	return request({
		url: apiUrl.FORGET,
		data,
	});
}
// 修改账户
export function updateLoginName(data) {
	return request({
		url: apiUrl.UPDATE_LOGIN_NAME,
		data,
	});
}

// 修改昵称
export function updateUserName(data) {
	return request({
		url: apiUrl.UPDATE_USER_NAME,
		data,
	});
}

// 修改手机号
export function updatePhone(data) {
	return request({
		url: apiUrl.UPDATE_PHONE,
		data,
	});
}

// 第三方单点登录
export function thirdLogin(data) {
	return request({
		url: apiUrl.THIRD_LOGIN,
		data,
		headers: {
			'Content-type': 'text/plain'
		}
	});
}